export default "__VITE_ASSET__BGcQiSF0__"